import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import "./OrganizationDescription.css";

interface Props {
  formData: any;
  setFormData: React.Dispatch<React.SetStateAction<any>>;
}

const OrganizationDescription: React.FC<Props> = ({ formData, setFormData }) => {
  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev: any) => ({ ...prev, [name]: value }));
  };

  return (
    <div className="p-4">
      <h2 className="contact-information-heading">Contact Information</h2>
      <Form>
        <Row>
          <Col lg={10}>
            <Row>
              <Col md={6}>
                <Form.Group controlId="Contact_Surname__c" className="mb-3 d-flex align-items-center">
                  <Form.Label className="me-2 mb-0" style={{ width: "220px"}}>Contact Surname</Form.Label>
                  <Form.Control
                    type="text"
                    name="Contact_Surname__c"
                    value={formData.Contact_Surname__c || ""}
                    onChange={handleInputChange}
                    placeholder="Type here"
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="Contact_First_Name__c" className="mb-3 d-flex align-items-center">
                  <Form.Label className="me-2 mb-0" style={{ width: "250px"}}>Contact First Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="Contact_First_Name__c"
                    value={formData.Contact_First_Name__c || ""}
                    onChange={handleInputChange}
                    placeholder="Type here"
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Form.Group controlId="Street_Address__c" className="mb-3 d-flex align-items-center">
              <Form.Label className="me-2">Street Address</Form.Label>
              <Form.Control
                type="text"
                name="Street_Address__c"
                value={formData.Street_Address__c || ""}
                onChange={handleInputChange}
                placeholder="Type here"
                style={{ flex: 2 }}
                required
              />
            </Form.Group>

            <Row>
              <Col md={4}>
                <Form.Group controlId="Phone_Cell__c" className="mb-3 d-flex align-items-center">
                  <Form.Label className="me-2 mb-0">Phone/Cell</Form.Label>
                  <Form.Control
                    type="text"
                    name="Phone_Cell__c"
                    value={formData.Phone_Cell__c || ""}
                    onChange={handleInputChange}
                    placeholder="Type here"
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group controlId="Email__c" className="mb-3 d-flex align-items-center">
                  <Form.Label className="me-2 mb-0">Email</Form.Label>
                  <Form.Control
                    type="email"
                    name="Email__c"
                    value={formData.Email__c || ""}
                    onChange={handleInputChange}
                    placeholder="Type here"
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group controlId="Website__c" className="mb-3 d-flex align-items-center">
                  <Form.Label className="me-2 mb-0">Websites</Form.Label>
                  <Form.Control
                    type="text"
                    name="Website__c"
                    value={formData.Website__c || ""}
                    onChange={handleInputChange}
                    placeholder="Type here"
                    disabled 
                  />
                </Form.Group>
              </Col>
            </Row>
          </Col>
        </Row>

        <Form.Group controlId="General_Description__c" className="mt-3 mb-4">
          <Form.Label className="form-description-label">General Description of Organization</Form.Label>
          <Form.Control
            as="textarea"
            rows={4}
            name="General_Description__c"
            value={formData.General_Description__c || ""}
            onChange={handleInputChange}
            placeholder="Add a description..."
          />
        </Form.Group>
      </Form>
    </div>
  );
};

export default OrganizationDescription;
